export const WINDOWS_SETUP_TASK_KEYS = [
  'inputMethodInstalled',
  'inputSourceEnabled',
  'inputSourceSelected',
  'systemTextSuggestionsDisabled',
  'backgroundActivityEnabled'
]

export const normalizeWindowsSetupStatus = value => {
  if (!value || typeof value !== 'object' || value.available !== true ||
      !value.tasks || typeof value.tasks !== 'object') {
    return null
  }

  const tasks = WINDOWS_SETUP_TASK_KEYS.reduce((result, key) => {
    result[key] = value.tasks[key] === true
    return result
  }, {})

  return {
    available: true,
    tasks,
    complete: WINDOWS_SETUP_TASK_KEYS.every(key => tasks[key])
  }
}

export const shouldShowWindowsSetup = status =>
  Boolean(status && status.available === true && status.complete !== true)

export const completedWindowsSetupTaskCount = status => {
  if (!status || !status.tasks) return 0
  return WINDOWS_SETUP_TASK_KEYS.filter(key => status.tasks[key] === true).length
}
